import $ from 'jquery';
import Deleter from '@/lib/deleter.js';

export default function () {
	new Deleter('.deleter');

	$('#activate-volume-entry-pricing').on('change', function () {
		const checked = $(this).prop('checked');
		const form = $(this).parents('form');
		const action = form.attr('action').split('/').slice(3);
		$('.volume-entry-pricing').toggleClass('hidden', !checked);
		$.post(action, form.serialize());
	});

	$('#activate-related-entries-pricing').on('change', function () {
		$('.related-entries-pricing').toggleClass('hidden', !$(this).prop('checked'));
	});

	const updateRelatedEntriesAction = function () {
		$('.related-entries-action-options').addClass('hidden');
		$('.related-entries-action-' + $('#related-entries-action').val()).removeClass('hidden');
	};

	$('#related-entries-action').on('change', updateRelatedEntriesAction);

	updateRelatedEntriesAction();
}
